import React from "react";
import { Api } from "../app-controller.js";
import Swal from "sweetalert2";
import ProductWithdrawal from "../components/products/ProductWithdrawal";

class MoveProducts extends React.Component {
  initialState = {
    nivelUsuario: localStorage.nivel_actual,
    establecimiento: "",
    cat_motivo_baja: Api.loadCatalogue("cat_motivo_baja"),
    cat_paises: Api.loadCatalogue("countries"),
    cat_establecimiento: [],
    cat_producto: [],
    cat_presentacion: [],
    cat_num_lote: [],
    cat_actividades: [],
    actividad: "",
    productos_info: "",
    producto: "",
    presentacion: "",
    num_lote: "",
    cantidad: "",
    motivo_baja: "",
    observacion: "",
    pais_exportacion: "",
  };

  constructor(props) {
    super(props);

    this.getEstablishmentsByRegent = this.getEstablishmentsByRegent.bind(this);
    this.handleEstablecimientoChange =
      this.handleEstablecimientoChange.bind(this);
    this.handleCantidadChange = this.handleCantidadChange.bind(this);
    this.checkPositiveIntegers = this.checkPositiveIntegers.bind(this);
    this.resetValues = this.resetValues.bind(this);
    this.handleProductoChange = this.handleProductoChange.bind(this);
    this.handlePresentacionChange = this.handlePresentacionChange.bind(this);
    this.handleLoteChange = this.handleLoteChange.bind(this);
    this.handleMotivoBajaChange = this.handleMotivoBajaChange.bind(this);
    this.handlePaisChange = this.handlePaisChange.bind(this);
    this.handleObservacionChange = this.handleObservacionChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.handleValidations = this.handleValidations.bind(this);
    this.resetStates = this.resetStates.bind(this);
    this.filterCatMotivoBaja = this.filterCatMotivoBaja.bind(this);
    this.cleanErrorsValidation = this.cleanErrorsValidation.bind(this);
    this.handleActividadChange = this.handleActividadChange.bind(this);
    this.getProductByEstablishmentInBitacoraCantidades =
      this.getProductByEstablishmentInBitacoraCantidades.bind(this);
    this.getActividadesEstablecimiento =
      this.getActividadesEstablecimiento.bind(this);

    this.state = this.initialState;
  }

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    // fn para filtrar catálogo de actividades, para este apartado solo necesitamos importandor, alamacenador, distribuidor y farmacia veterinaria
    this.getEstablishmentsByRegent();

    this.filterCatMotivoBaja();
  }

  /********* LLAMADAS A LA API ***********/

  getEstablishmentsByRegent() {
    Api.loading(true);
    Api.fetch("app/getEstablishmentsByRegent")
      .then((data) => {
        if (data) {
          this.setState({ cat_establecimiento: data });
        }
      })
      .then((data) => Api.loading(false));
  }

  /********** FUNCIONES PARA CONTROLAR EVENTOS **********/

  handleEstablecimientoChange(obj) {
    this.resetValues();

    // Asignamos el valor a establecimiento
    this.setState({
      establecimiento: obj,
    });

    // buscamos los productos pertenecientes al establecimento seleccionado en la tabla bitacora_cantidades
    this.getProductByEstablishmentInBitacoraCantidades(obj.id);

    // buscamos las actividades correspondientes al establecimiento
    this.getActividadesEstablecimiento(obj.id);

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("establecimiento");
  }

  handleCantidadChange(evt) {
    let num_lote = this.state.num_lote;
    // Asignamos el valor a establecimiento
    if (this.checkPositiveIntegers(evt.target.value)) {
      if (parseInt(evt.target.value) > parseInt(num_lote.cantidad)) {
        document.getElementById("cantidad-error").style.display = "block";
        document.getElementById(
          "cantidad-error"
        ).innerText = `Este lote solo cuenta con ${num_lote.cantidad} existencias.`;
        document.getElementById("cantidad").classList.add("is-invalid");
      } else {
        // limpamos errores si es que los hay
        this.cleanErrorsValidation("cantidad");
      }
      this.setState({ cantidad: evt.target.value });
    }

    // // limpamos errores si es que los hay
    // this.cleanErrorsValidation("cantidad");
  }

  // funcion para validar solo enteros positivos en un input
  checkPositiveIntegers(str) {
    let regex = /^[1-9]\d{0,9}$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  }

  resetValues() {
    this.setState({
      producto: this.initialState.producto,
      presentacion: this.initialState.presentacion,
      num_lote: this.initialState.num_lote,
      cantidad: this.initialState.cantidad,
      // motivo_baja: this.initialState.motivo_baja,
      // pais_exportacion: this.initialState.pais_exportacion,
      cat_presentacion: this.initialState.cat_presentacion,
      cat_producto: this.initialState.cat_producto,
      cat_num_lote: this.initialState.cat_num_lote,
      cat_actividades: this.initialState.cat_actividades,
      actividad: this.initialState.actividad,
    });
  }

  handleProductoChange(obj) {
    let cat_presentacion = this.state.productos_info.empaques;

    // filtramos el catalogo de empaques/presentacion por el producto id seleccionado
    cat_presentacion = cat_presentacion.filter(
      (item) => item.producto_id === obj.id
    );

    // Asignamos el valor a producto
    this.setState({
      producto: obj,
      cat_presentacion,
      presentacion: this.initialState.presentacion,
      num_lote: this.initialState.num_lote,
      cantidad: this.initialState.cantidad,
      motivo_baja: this.initialState.motivo_baja,
    });

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("producto");
  }

  handlePresentacionChange(obj) {
    let cat_num_lote = this.state.productos_info.lotes,
      producto = this.state.producto;

    // filtramos el catalogo de lotes/presentacion por el producto id seleccionado
    cat_num_lote = cat_num_lote.filter(
      (item) => item.producto_id === producto.id && item.id === obj.id
    );

    // Asignamos el valor a presentacion
    this.setState({
      presentacion: obj,
      cat_num_lote,
      num_lote: this.initialState.num_lote,
      cantidad: this.initialState.cantidad,
    });

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("presentacion");
  }

  handleLoteChange(obj) {
    // Asignamos el valor a presentacion
    this.setState({
      num_lote: obj,
      cantidad: this.initialState.cantidad,
      motivo_baja: this.initialState.motivo_baja,
    });

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("num_lote");
  }

  handleMotivoBajaChange(obj) {
    // Asignamos el valor a presentacion
    this.setState({
      motivo_baja: obj,
      pais_exportacion: this.initialState.pais_exportacion,
    });

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("motivo_baja");
  }

  handlePaisChange(obj) {
    // Asignamos el valor a pais_exportacion
    this.setState({
      pais_exportacion: obj,
    });

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("pais_exportacion");
  }

  handleObservacionChange(evt) {
    // Asignamos el valor a observacion
    this.setState({
      observacion: evt.target.value.toUpperCase(),
    });

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("observacion");
  }

  handleActividadChange(obj) {
    // Asignamos el valor a actividad
    this.setState({
      actividad: obj,
    });

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("actividad");
  }

  getProductByEstablishmentInBitacoraCantidades(establecimiento_id) {
    Api.loading(true);
    Api.fetch(
      "app/getProductByEstablishmentInBitacoraCantidades?establecimiento_id=" +
        establecimiento_id
    )
      .then((data) => {
        if (data) {
          this.setState({ cat_producto: data.productos, productos_info: data });
        }
      })
      .then((data) => Api.loading(false));
  }

  getActividadesEstablecimiento(establecimiento_id) {
    Api.loading(true);

    Api.fetch(
      "app/getActividadesEstablecimiento?establecimiento_id=" +
        establecimiento_id
    )
      .then((data) => {
        this.setState({ cat_actividades: data });
      })
      .then((res) => Api.loading(false));
  }

  handleSubmit(evt) {
    evt.preventDefault();

    let productData = { ...this.state };
    // delete productData.cat_producto;
    // delete productData.cat_num_lote;
    // delete productData.cat_motivo_baja;
    // delete productData.cat_presentacion;

    Swal.fire({
      icon: "question",
      title: "¿Completar transacción?",
      text: "¡Asegúrese que los datos estén completados correctamente!",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.submitForm(productData);
      }
    });
  }

  submitForm(productData) {
    Api.loading(true);
    Api.fetch("app/storeProductWithdrawal", productData, "POST").then(
      (data) => {
        if (data.errors) {
          this.handleValidations(data.errors);
          Api.loading(false);
          this.fireSwal(
            "¡Verifique que los datos esten correctamente completados!",
            "warning"
          );
          return false;
        } else {
          Api.loading(false);
          Swal.fire({
            icon: "success",
            title: `La baja de producto ha sido exitosa`,
            confirmButtonText: "Continuar",
            timer: 3000,
          }).then(() => {
            window.location.href = "/productos/baja";
          });
          this.resetStates();
        }
      }
    );
  }

  // fn para marcar los campos que duevelen error desde la api
  handleValidations(errors) {
    for (const i in errors) {
      document.getElementById(i + "-error").style.display = "block";
      document.getElementById(i + "-error").innerText = errors[i];
      document.getElementById(i).classList.add("is-invalid");
    }
  }

  // fn para depslegar mensajes de alerta sencillos
  fireSwal(title, icon = "error") {
    Swal.fire({
      title: title,
      icon: icon,
      timer: 3000,
      confirmButtonText: "Regresar",
    });
    return false;
  }

  // fn para reiniciar todos los estados una vez el submit sea éxitoso
  resetStates() {
    this.setState({
      actividad: this.initialState.actividad,
      establecimiento: this.initialState.establecimiento,
      cat_establecimiento: this.initialState.cat_establecimiento,
      cat_producto: this.state.cat_producto,
      cat_presentacion: this.state.cat_presentacion,
      cat_num_lote: this.state.cat_num_lote,
      productos_info: this.initialState.productos_info,
      producto: this.initialState.producto,
      presentacion: this.initialState.presentacion,
      num_lote: this.initialState.num_lote,
      cantidad: this.initialState.cantidad,
      motivo_baja: this.initialState.motivo_baja,
      observacion: this.initialState.observacion,
      pais_exportacion: this.initialState.pais_exportacion,
    });
  }

  /*********** Funciones ***********/

  filterCatMotivoBaja() {
    let catMotivoBaja = this.state.cat_motivo_baja;

    catMotivoBaja = catMotivoBaja.filter((motivo) => motivo.id !== "1");

    this.setState({ cat_motivo_baja: catMotivoBaja });
  }

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation(elemento) {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  }

  render() {
    return (
      <ProductWithdrawal
        state={this.state}
        handleCantidadChange={this.handleCantidadChange}
        handleEstablecimientoChange={this.handleEstablecimientoChange}
        handleProductoChange={this.handleProductoChange}
        handlePresentacionChange={this.handlePresentacionChange}
        handleLoteChange={this.handleLoteChange}
        handleSubmit={this.handleSubmit}
        handleMotivoBajaChange={this.handleMotivoBajaChange}
        handleObservacionChange={this.handleObservacionChange}
        handlePaisChange={this.handlePaisChange}
        handleActividadChange={this.handleActividadChange}
      />
    );
  }
}

export default MoveProducts;
